import { Genders } from 'Constants';
import i18n from './i18n';
/** Reference used to store urls */
export const urls = {
    apiUrl: '',
};
/**
 * Sets the urls object to be ready for services
 * - config: object - The environment config
 */
export const setUrls = (config, country) => {
    const { apiCountryUrls } = config;
    urls.apiUrl = apiCountryUrls?.[country] ? normalizeUrl(apiCountryUrls[country]) : '';
};
export const setInitialApiUrl = (config, app) => {
    const apiUrl = app === 'llu5' ? config.lluApiUrl : config.libreApiUrl;
    urls.apiUrl = normalizeUrl(apiUrl);
};
export const getDocumentPathFromLanguage = (document, lang) => {
    if (!document) {
        return '';
    }
    const path = document[lang.toLowerCase()] || document.default || document['en-us'];
    return path;
};
export const detectTheme = (urlParams) => {
    const productParam = urlParams.get('product');
    const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'Dark' : 'Light';
    return !productParam || productParam === 'libre1' ? `polaris${theme}` : `otc${theme}`;
};
export const getTheme = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const themeParam = urlParams.get('theme');
    return themeParam ? themeParam : detectTheme(urlParams);
};
export const getApp = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const app = (urlParams.get('app') || urlParams.get('product'));
    return app ?? 'libre1';
};
export const getUserResourcePath = (app) => {
    switch (app) {
        case 'libre1':
            return 'patients';
        case 'llu5':
            return 'caregivers';
        default:
            return 'patients';
    }
};
export const getUpdateUserMethod = (app) => {
    switch (app) {
        case 'libre1':
            return 'PUT';
        case 'llu5':
            return 'PATCH';
        default:
            return 'PATCH';
    }
};
export const getUpdatePasswordPath = (app) => {
    switch (app) {
        case 'libre1':
            return 'accounts';
        case 'llu5':
            return 'caregivers';
        default:
            return 'accounts';
    }
};
export const getTermsOfUseId = (app) => {
    switch (app) {
        case 'libre1':
            return 'touLibre';
        case 'llu5':
            return 'toullu';
        default:
            return 'touLibre';
    }
};
export const generateUserAgentHeader = (app, appVersion, osType, osVersion) => {
    return `${app ?? 'none'};${appVersion ?? 'none'};${osType ?? 'none'};${osVersion ?? 'none'}`;
};
export const normalizeUrl = (url) => {
    const normalizedUrl = url.replace(/\/v1\/?$/, '/');
    return normalizedUrl;
};
export const validateFrenchZipCode = (zipCode) => {
    if (!zipCode) {
        return false;
    }
    const regex = new RegExp(/^\d{5}$/);
    return regex.test(zipCode);
};
export const getGenderDisplayText = (gender) => {
    if (!gender) {
        return '';
    }
    const cmsKey = gender === Genders.UNDETERMINED ? 'other' : gender;
    return i18n.t(`Global.microcopy.genderOptions.${cmsKey}`);
};
